player.playerTickets = {
    // Funkcia na vyrendrovanie mojich tiketov
    myTicketsRender: function(data) {
        try {
            $('#myTicketsContainer').show();
            
            if (data) {
                data.activeGroup = stored.myTicketsActiveGroup;

                if (stored.FbBonButtons.fb || stored.FbBonButtons.bon) {
                    // Skryje tlacidla freebet, bonifikacia
                    ticket.ticketPromoModule.freebetBonificationShowButtons(true);
                }

                $("#footer-sidebar .simple-options").show();
                $("#ticket #myTicketsList").empty();

                if (data.TicketCount) {
                    $("#myTicketsEmpty").hide();
                    // Existuju tikety pod danou skupinou - Render
                    $p("#ticket #myTicketsList").render(data, T.myTickets);

                    // Oznaci aktualnu skupinu 
                    $(".my-tickets-button").removeClass('selected');
                    $("#myTickets" + stored.myTicketsActiveGroup).addClass('selected');

                    // Skryje filter
                    $("#myTicketsFilterCollapsible").trigger("collapse");

                    shared.scrollModule.scrollOnTapAndHold("myTicketsList");

                } else {
                    // Neexistuju tikety v danej skupine - zobrazi hlasku
                    $("#ticket #myTicketsList").append('<div id="myTicketsEmpty"><div class="icon-error"></div>' +
                    texts.MyTicketsEmpty + '</div>');
                    // Zobrazi filter
                    $("#myTicketsFilterCollapsible").trigger("expand");

                    // Oznaci aktualnu skupinu 
                    $(".my-tickets-button").removeClass('selected');
                    $("#myTickets" + stored.myTicketsActiveGroup).addClass('selected');
                }

                // Nastavi nazov filtra
                $("#myTicketsFilterLabel .ui-btn-text").text(texts['MyTickets' + stored.myTicketsActiveGroup]);


            } else {
                // Neprisli data - prejde na typ ktory bol naposledy zobrazeny na UI
                ticket.ticketTypeSwitch(ticket.state.getState().type);
            }
        } catch(e) {
            // Prejde na typ ktory bol naposledy zobrazeny na UI
            ticket.ticketTypeSwitch(ticket.state.getState().type);
        }
    },

    // Vycistenie mojich tiketov
    clearMyTickets: function(disable) {
        try {
            delete cache.MyTickets;
            $("#ticket #myTicketsList").empty();
            if (disable) {
                $("#ticketTop #myTickets").addClass("ui-disabled");
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na prepinanie typov mojich tiketov
    myTicketsFilter: function(type, forceUpdate) {
        try {
            if (profile.MyTickets.length && stored.PlayerID) {
                if (forceUpdate) {
                    delete cache.MyTickets;
                }
                if (type && type !== "0") {
                    stored.myTicketsActiveGroup = type;
                } else {
                    stored.myTicketsActiveGroup = "Last";
                }
                if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                    ticket.ticketTypeSwitch(ticket.state.ticketTabs.MT);
                }

                return true;
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia parsuje pocty oddov s konkretnymi statusmi
    parseOddsStatus: function(oddsStatusString) {
        try {
            if (oddsStatusString) {
                var win, loss, pend, canceled = 0;
                if (win = oddsStatusString.split("Y=")[1]) {
                    win = win.split(",")[0];
                }
                if (loss = oddsStatusString.split("N=")[1]) {
                    loss = loss.split(",")[0];
                }
                if (pend = oddsStatusString.split("U=")[1]) {
                    pend = pend.split(",")[0];
                }
                if (canceled = oddsStatusString.split("S=")[1]) {
                    canceled = canceled.split(",")[0];
                }
                return {
                    "win": win,
                    "loss": loss,
                    "pend": pend,
                    "canceled": canceled
                }
            }
            return false;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};

// Odchytenie rozbalenia Filtra mojich tiketov
$("#myTicketsFilterCollapsible").live("expand", function () {
    var myTicketsListLength = (stored.myTicketsContainerLength - $('#myTicketsFilterCollapsible').height() - $('#myTicketsLabel').height());
    $("#ticket #myTicketsList").height(myTicketsListLength).animate({maxHeight: myTicketsListLength + "px"}, 0);
});

// Odchytenie zbalenia Filtra mojich tiketov (default)
$("#myTicketsFilterCollapsible").live("collapse", function () {
    var myTicketsListLength = (stored.myTicketsContainerLength - $('#myTicketsLabel').height());
    $("#ticket #myTicketsList").height(myTicketsListLength).animate({maxHeight: myTicketsListLength + "px"}, 0);
});
